<template>
  <div class="edit-sensor-alarms">
    <div class="edit-sensor-alarms__column">
      <transition-group
        name="alarm--transition"
        tag="div"
      >
        <sensor-alarm
          v-for="alarm in alarms"
          :key="alarm.data.id"
          :alarm-data="alarm"
          :triggers="triggers"
          :senstype="sensorData.data.senstype"
          :sensors="sensors"
          :ctrlid="sensorData.data.ctrlid"
          :page-message = "PageMessage"
          @delete="deleteClicked(alarm)"
          @SetPageMessage="SetPageMessage"
        />
      </transition-group>
      
      <div class="edit-sensor-alarms__controls">
        <button
          class="g-btn g-btn--rounded g-btn--blue"
          :class="{'disabled': disableCreate}"
          :disabled="disableCreate"
          @click.stop="createAlarmButtonClicked(createBlankAlarm())"
        >
          <span v-if="!disableCreate">
            {{ $t('messages.sensors.sdAlarms.createalarm') }}
          </span>
          <font-awesome-icon
            v-else
            :icon="['fas', 'circle-notch']"
            :spin="true"
          />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {SocketHandler, LifeCycle} from '@/assets/javascript/mixins/Mixins'
import SensorDecoderAlarmcomponent from'@/components/elements/SensorDecoderAlarmComponent.vue'
import{MicroService} from'@/assets/javascript/mixins/Mixins'
import {convertToOptions} from '@/assets/javascript/utilities'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

export default {
  name: 'EditSensorDecoderAlarms',
  components: {
    'sensor-alarm': SensorDecoderAlarmcomponent,
    'font-awesome-icon': FontAwesomeIcon
  },
  mixins: [SocketHandler, LifeCycle, MicroService],
  props: {
    PageMessage: {
      type: Object,
      default: function() {
        return {}
      }
    },
    sensors: {
      type: Number,
      default: 0
    },
    sensorData: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      alarms: [],
      triggers: [],
      disableCreate: false
    }
  },
  watch: {
    PageMessage(msg) {
      if(
        msg &&
        msg.target === 'sensor-decoder-alarm-delete'
      ) {
        const match = this.alarms.find(alarm => alarm.data.id === msg.data.data.id)
        if(match) this.deleteAlarm(match)
      }
    }
  },
  mounted() {
    this.getAlarms()
    this.getTriggers()
  },
  methods: {
    SetPageMessage(Message) {
      this.$emit('SetPageMessage', Message)
    },
    createBlankAlarm() {
      return {
        ctrlid: this.sensorData.data.ctrlid,
        sensid: this.sensorData.data.id,
        seqno: this.alarms.length + 1,
        index: null,
        alrmname: null,
        alrmtype: null,
        limit: null,
        condition: null,
      }
    },
    deleteClicked(data) {
      console.log(JSON.stringify(data))
      const text = this.alarms.length
      ? 'Deleting this alarm will also delete its actions & sub-actions.'
      : ''

      this.$emit('SetPageMessage', {
        target: 'ShowModal',
        modalData: {
          component: 'DialogueModal',
          data: {
            title: 'Delete Action?',
            prefix: 'sensor-decoder-alarm-',
            text,
            data,
            options: [
              {label: 'Delete', value: 'delete'}, {label: 'Cancel', value: 'cancel'}
            ]
          }
        }
      })
    },
    createAlarmButtonClicked(data) {
      console.log('data', data)
      this.disableCreate = true
      this.sendMicroServiceRequest({
        method: 'PUT',
        url: `api/authenticated/function/createsdalarm?senstype=${this.sensorData.data.senstype}`,
        data
      })
      .then((response) => {
        if(response.data && response.data.createsdalarm)
          this.alarms.push(response.data.createsdalarm[0])
          let Msg = { category: 'server', command: 'synchronize', data: { 'type': 'initiate' } }
          this.SocketMessageSend( Msg )
      })
      .catch(console.error)
      .finally(() => this.disableCreate = false)
    },
    deleteAlarm(data) {
      const alarmIndex = this.alarms.indexOf(data)
      if(alarmIndex === -1) return this.$emit('delete', data)

      this.sendMicroServiceRequest({
        method: 'DELETE',
        url: `api/authenticated/function/deletesdalarm?ctrlid=${this.sensorData.data.ctrlid}&id=${data.id}`,
        data
      }).then((response) => {
        if(response.status !== 200) console.error(response)
        if(response.data.deletesdalarm) this.alarms.splice(alarmIndex, 1)
        let Msg = { category: 'server', command: 'synchronize', data: { 'type': 'initiate' } }
        this.SocketMessageSend( Msg )
      }).catch(console.error)
    },
    getAlarms() {
      this.sendMicroServiceRequest({
        method: 'GET',
        url: `api/authenticated/function/getsdalarm?id=${this.sensorData.data.id}`
      })
      .then((response) => {
        response.data
        ? this.$set(this, 'alarms', response.data.getsdalarm)
        : console.error('no data for getsdalarm')
      }).catch(console.error)
    },
    getTriggers() {
      this.sendMicroServiceRequest({
        method: 'GET',
        url: `api/authenticated/function/getsdalarmdropdown?&senstype=${this.sensorData.data.senstype}&language_code=en-US`
      })
      .then((response) => {
        response.data
        ? this.$set(this, 'triggers', convertToOptions(response.data.getsdalarmdropdown, 'enum', 'lang'))
        : console.error('no data for getsdalarmdropdown')
      }).catch(console.error)
    }
  }
}
</script>
<style lang="scss">
.edit-sensor-alarms {
  input, select {
    font-size: 12px;
  }

  h4 {
    font-size: 12px;
    margin: 23px 5px 5px;
    word-wrap: none;
    white-space: nowrap;
  }

  .g-btn, select {
    border-radius: 0;
    border: 1px solid $color-grey;
    border-right: 0;

    &--red {
      border: 1px solid $color-red-error;
    }
  }
  .g-btn--toggle::after {
    height: 100%;
    border-radius: 0;
  }
  &__controls {
    margin: 20px 0;
    text-align: center;

    .g-btn {
      width: 100%;
      margin: 0;
      padding: 8px 10px;
      font-size: 16px;
    }
  }

  
	.alarm--transition {
		&-enter {
			opacity: 0;
		}
		&-enter-to {
			transition: all 0.4s;
			opacity: 1;
		}
		&-leave-to {
			transition: all 0.3s;
			opacity: 0;
		}
		// &-leave-active {
		// 	position: absolute;
		// }
		&-move {
			transition: transform 0.4s;
		}
  }
}
</style>